
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Component} from "vue-property-decorator";
import { PaymentSettingsRequestType } from "./pyment.type";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {maxLength, minLength, numeric, required} from "vuelidate/lib/validators";

@Component
export default class PaymentSettingsForm extends Form {

    @Validate(required, i18nText("Выберите кассу для наличных"))
    payment_cash_box_id: number | null = null;
    @Validate(required, i18nText("Выберите кассу для онлайн оплаты"))
    online_payment_cash_box_id: number | null = null;


    getFormData(): PaymentSettingsRequestType {
       return{
        payment_cash_box_id: this.payment_cash_box_id,
        online_payment_cash_box_id: this.online_payment_cash_box_id,
       } 
    }

    setFormData(): void {}
}
